import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import {
  fetchHomeCategories,
  fetchHomeLocationArticles,
  getVasimiOcami,
  getHomeArticleFromTvKosice,
  getHomeArticleFromRadioKosice,
} from './../actions';
import { getArticles, getSection } from './../../ui/src/actions.js';
import { LoadMore } from './../../ui/src/component/loadMore';
import { CsmSectionLink } from './../../ui/src/component/csmSectionLink';
import CsmArticleLink from '../component/csmArticleLink';
import { Icon } from './../../ui/src/component/icon/';
import { WeatherWidget } from './../component/weatherWidget';
import { CalendarWidget } from './../component/calendarWidget';
import StandardArticle from '../component/standardArticle';
import Banner from '../component/banner';

import { StandardArticleCustom } from './../component/standardArticleCustom';
import ArticleTiles from '../component/articleTiles/index';
import Api from './../../ui/src/api.js';
import {
  imageBaseUrl,
  imageResizeBaseUrl,
  getProp,
} from './../../ui/src/utilities.js';

import moment from 'moment';
import { SectionName } from '../../ui/src/component/csmSectionLink/csmSectionLink';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      homeCategoriesShowCount: 5,
      namedays: [],
    };
  }

  componentDidMount() {
    Home.fetchDataHelper(this.props.dispatch).catch(() => {});
    Api.get('/cm/public/namedays').then(response => {
      this.setState({ namedays: response });
    });
  }

  onClickShowMoreCategories() {
    this.setState({
      homeCategoriesShowCount: this.props.homeCategories.length,
    });
  }

  render() {
    const {locationSmartTags} = this.props;
    const topArticles = getProp(this.props, 'topArticles', []).slice(0, 6);
    let rozhovory = [];
    if (this.props.homeCategories.length > 1) {
      rozhovory.push(this.props.homeCategories[0]);
      rozhovory.push(this.props.homeCategories[1]);
      rozhovory.push(this.props.homeCategories[2]);
    }
    const homeCategories = this.props.homeCategories.slice(
      3,
      this.state.homeCategoriesShowCount,
    );

    const vasimiOcamiSection = this.props.sections.byId['vasimi-ocami'];

    return (
      <div>
        <div className="bg-alt-light">
          <div className="container">
            <div className="nameday">
              <Nameday data={this.state.namedays} />
            </div>
          </div>
        </div>

        {topArticles.length === 6 ? (
          <div className="bg-alt-light home-featured section">
            <div className="container">
              <ArticleTiles
                articles={topArticles.map(item => {
                  return (
                    <StandardArticleCustom pictureSize={990} article={item} locationSmartTags={locationSmartTags} />
                  );
                })}
              />
            </div>
          </div>
        ) : null}
        <div className="container">
          <Banner id="banner-kosiceonline-sk-nad-lokality" />
        </div>
        <div className="container">
          <div className="section location-articles">
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {this.props.locationArticles.map(location => {
                let articles = getProp(location, 'articles.articles', []);
                let first = articles[0] ? articles[0] : null;
                let otherArticles = articles.slice(1);
                return (
                  <div key={location.id} className="col-md-4 location-wraper">
                    <Link to={`/lokalita/${location.id}`}>
                      <h3 className="h2">
                        {location.title}{' '}
                        <Icon name="chevron-circle-right" className="icon-md" />
                      </h3>
                    </Link>
                    <div>
                      {first && <StandardArticleCustom isLocationArticle={true} article={first} locationSmartTags={locationSmartTags} />}
                      {otherArticles.length > 0 && (
                        <ul>
                          {articles.slice(1).map(item => {
                            return (
                              <li key={item._id} style={{ padding: 0 }}>
                                <CsmArticleLink article={item}>
                                  {item.picture && (
                                    <div className="col-xs-3 col-sm-2 col-md-3 col-lg-3">
                                      <div
                                        className="small-articles"
                                        style={{
                                          backgroundImage: `url('${imageResizeBaseUrl(
                                            200,
                                            200,
                                          )}/${item.picture.uri}')`,
                                        }}
                                      >
                                        <div className="layer" />
                                      </div>
                                    </div>
                                  )}
                                </CsmArticleLink>
                              </li>
                            );
                          })}
                        </ul>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="container">
          <Banner id="banner-kosiceonline-sk-nad-pocasie" />
        </div>

        <div className="container-fluid bg-alt-light">
          <div className="row">
            <div className="widget-area">
              <div className="container">
                <div className="row">
                  <div className="col-md-6 widget-left">
                    <WeatherWidget />
                  </div>
                  <div className="col-md-6 widget-right widget-darker">
                    <CalendarWidget />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container vasimi-ocami">
          {vasimiOcamiSection && (
            <div style={{ marginTop: '60px' }}>
              <CsmSectionLink section={vasimiOcamiSection.section}>
                <h1>
                  <SectionName>{vasimiOcamiSection.section.name}</SectionName>{' '}
                  <Icon name="chevron-circle-right" className="icon-md" />
                </h1>
              </CsmSectionLink>
              <div className="flex-row row">
                {this.props.vasimiOcamiArticles.map(item => {
                  return (
                    <div
                      key={item._id}
                      className="flex-col col-xs-12 col-sm-6 col-md-3 smaller-padding"
                    >
                      <StandardArticle
                        article={item}
                        articleTitleSubtitle={null}
                        extended={true}
                        articleAuthorShow={true}
                        articleAuthorSubtitle={
                          <CsmSectionLink
                            section={vasimiOcamiSection.section}
                          />
                        }
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          {rozhovory.map(section => {
            return (
              <div key={section._id} style={{ marginTop: '50px' }}>
                <CsmSectionLink section={section}>
                  <h1>
                    <SectionName>{section.name}</SectionName>{' '}
                    <Icon name="chevron-circle-right" className="icon-md" />
                  </h1>
                </CsmSectionLink>
                <div className="row flex-row">
                  {getProp(section, 'articles.articles', []).map(item => {
                    return (
                      <div
                        key={item._id}
                        className="flex-col col-xs-12 col-sm-6 col-md-3 smaller-padding"
                      >
                        <StandardArticleCustom article={item} />
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}

          {this.props.homeTvKosiceArticle && (
            <div className="tv-kosice">
              <div className="section">
                <a href="https://www.tvkosice.sk" target="_blank" rel="noopener noreferrer">
                  <h2 className="h1">
                    TV Košice{' '}
                    <Icon name="chevron-circle-right" className="icon-md" />
                  </h2>
                </a>
                <ArticleTiles
                  articles={this.props.homeTvKosiceArticle.map(item => (
                    <StandardArticleCustom
                      pictureSize={990}
                      article={item}
                      imgOverride={
                        imageBaseUrl(800) + '/' + getProp(item, 'picture.uri')
                      }
                      author={'Televízia Košice'}
                      baseUrl="https://www.tvkosice.sk"
                    />
                  ))}
                />
              </div>
            </div>
          )}
          {this.props.homeRadioKosiceArticle && (
            <div>
              <div className="section">
                <a href="https://www.radiokosice.sk" target="_blank" rel="noopener noreferrer">
                  <h2 className="h1">
                    Rádio Košice{' '}
                    <Icon name="chevron-circle-right" className="icon-md" />
                  </h2>
                </a>
                <ArticleTiles
                  articles={getProp(
                    this.props,
                    'homeRadioKosiceArticle',
                    [],
                  ).map(item => (
                    <StandardArticleCustom
                      pictureSize={990}
                      article={item}
                      author={'Rádio Košice'}
                      baseUrl="http://www.radiokosice.sk"
                    />
                  ))}
                />
              </div>
            </div>
          )}
        </div>
        {homeCategories.map(section => {
          return (
            <div key={section._id} className="container">
              <CsmSectionLink section={section}>
                <h2 style={{ fontWeight: '400' }}>
                  <SectionName>{section.name}</SectionName>{' '}
                  <Icon name="chevron-circle-right" className="icon-md" />
                </h2>
              </CsmSectionLink>
              <div className="row flex-row">
                {getProp(section, 'articles.articles', []).map(item => {
                  return (
                    <div
                      key={item._id}
                      className="flex-col col-xs-12 col-sm-6 col-md-3 smaller-padding"
                    >
                      <StandardArticleCustom article={item} />
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}

        {this.state.homeCategoriesShowCount <
          this.props.homeCategories.length && (
          <div className="text-center section">
            <LoadMore
              show={true}
              onClick={this.onClickShowMoreCategories.bind(this)}
            />
          </div>
        )}
      </div>
    );
  }
}

Home.fetchDataHelper = dispatch => {
  return Promise.all([
    dispatch(
      getArticles(
        process.env.REACT_APP_CONTENT_SPACE,
        'HOMEPAGE_TOP_ARTICLES',
        {
          limit: 6,
          sorter: 'pin2top',
        },
      ),
    ),
    dispatch(fetchHomeCategories()),
    dispatch(getSection(process.env.REACT_APP_CONTENT_SPACE, 'vasimi-ocami')),
    dispatch(getVasimiOcami()),
    dispatch(fetchHomeLocationArticles()),
    dispatch(getHomeArticleFromTvKosice()),
    dispatch(getHomeArticleFromRadioKosice()),
  ]);
};

Home.fetchData = ({ store }) => {
  return Home.fetchDataHelper(store.dispatch);
};

Home.propTypes = {
  dispatch: PropTypes.func.isRequired,
  homeCategories: PropTypes.array.isRequired,
  topArticles: PropTypes.array.isRequired,
  locationArticles: PropTypes.array.isRequired,
  vasimiOcamiArticles: PropTypes.array.isRequired,
  sections: PropTypes.object.isRequired,
  homeRadioKosiceArticle: PropTypes.array,
  homeTvKosiceArticle: PropTypes.array,
  locationSmartTags: PropTypes.array.isRequired,
};

const mapStateToProps = state => {
  return {
    sections: state.sections,
    homeCategories: state.homeCategories.data.sections,
    topArticles: state.homeTopArticles.data.articles,
    locationArticles: state.homeLocationArticles.data.values,
    vasimiOcamiArticles: state.homeVasimiOcamiArticles.data.articles,
    homeRadioKosiceArticle: state.homeRadioKosiceArticle.data,
    homeTvKosiceArticle: state.homeTvKosiceArticle.data,
    locationSmartTags:  state.locationSmartTags.data.values,
  };
};

export default connect(mapStateToProps)(Home);

const Nameday = props => {
  let date = getProp(props, 'data.now', null);
  if (date !== null) {
    date = moment(date).format('dddd, D. MMMM YYYY');
    date = `${date[0].toUpperCase()}${date.slice(1)}`;
  }

  let celebratesToday = getProp(props, 'data.today.names', []).join(', ');
  let titleToday = getProp(props, 'data.today.titles', []).join(', ');
  let celebratesTomorrow = getProp(props, 'data.tomorrow.names', []).join(', ');
  let titleTomorrow = getProp(props, 'data.tomorrow.titles', []).join(', ');

  let str = [date];

  if (celebratesToday) {
    let names = [];
    if (celebratesToday) {
      names.push(celebratesToday);
    }
    if (titleToday) {
      names.push(titleToday);
    }
    str.push(
      <span key={1}>
        {' '}
        | Meniny má: <strong>{names.join(', ')}</strong>
      </span>,
    );
  } else if (titleToday) {
    str.push(
      <span key={2}>
        {' '}
        | Dnes: <strong>{titleToday}</strong>
      </span>,
    );
  }

  if (celebratesTomorrow || titleTomorrow) {
    let names = [];
    if (celebratesTomorrow) {
      names.push(celebratesTomorrow);
    }
    if (titleTomorrow) {
      names.push(titleTomorrow);
    }
    str.push(
      <span key={3}>
        {' '}
        | Zajtra: <strong>{names.join(', ')}</strong>
      </span>,
    );
  }

  return <div>{str}</div>;
};



// WEBPACK FOOTER //
// ./src/app/container/home.js